import ValidatorOverview from '@modules/validators/ValidatorOverview';
import RecentlyAddedReports from '@modules/validators/RecentlyAddedReports';
import React from 'react';

const ValidatorDashboard = () => {
  return (
    <div>
      <section className="content">
        <div className="container-fluid">
          {/* <h1>Dashboard</h1> */}
          <RecentlyAddedReports />
          <ValidatorOverview />
        </div>
      </section>
    </div>
  );
};

export default ValidatorDashboard;
